import { useState } from "react";
import contactBannerImage from "../../../assets/images/contacto/contacto.png";
import styles from "./SectionFormContact.module.css";
import { toast } from "sonner";
const SectionFormContact = () => {
  const initialState = {
    nombre: "",
    telefono: "",
    asunto: "",
    correo: "",
    mensaje: "",
  };
  const [data, setData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (
      data["nombre"] === "" ||
      data["telefono"] === "" ||
      data["asunto"] === "" ||
      data["correo"] === "" ||
      data["mensaje"] === ""
    ) {
      toast.error("Todos los campos son obligatorios");
      return;
    }

    fetch("/revista/contacto.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.message);
          setData(initialState);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => toast.error("Ocurrio un error"));
  };

  return (
    <section className="w-100">
      {/* Banner */}
      <div className="position-relative w-100" style={{ height: 150 }}>
        <img
          src={contactBannerImage}
          alt="Contacto"
          className="position-absolute w-100 h-100 object-fit-cover"
          loading="lazy"
        />
        <div
          className="position-absolute d-flex align-items-center"
          style={{ height: 150, paddingLeft: "5%", color: "white" }}
        >
          <h1 className="m-0 fs-2 fw-bold">Contacto</h1>
        </div>
      </div>

      {/* Formulario */}
      <div className="text-dark py-5 px-3 px-md-5">
        <div className="container">
          <h2 className="fw-bold fs-3 text-center text-md-start">
            ¿Quieres publicarte en nuestras Revistas?
          </h2>
          <p className="fs-5 mx-5 mt-4 text-center text-md-start">
            Si te gustaría tener publicidad en la Revista Industrial de
            Monterrey, déjanos tus datos en el siguiente formulario
          </p>

          <form className={styles.form} onSubmit={handleFormSubmit}>
            <input
              type="text"
              name="nombre"
              placeholder="Nombre:"
              value={data.nombre}
              onChange={handleChange}
            />
            <input
              type="text"
              name="telefono"
              placeholder="Teléfono:"
              value={data.telefono}
              onChange={handleChange}
            />
            <input
              type="correo"
              name="correo"
              placeholder="Correo electrónico:"
              value={data.correo}
              onChange={handleChange}
            />
            <input
              type="text"
              name="asunto"
              placeholder="Asunto:"
              value={data.asunto}
              onChange={handleChange}
            />
            <textarea
              name="mensaje"
              placeholder="Mensaje:"
              rows="5"
              value={data.mensaje}
              onChange={handleChange}
            />
            <button type="submit">Enviar</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SectionFormContact;
